/**
 * Route classification helpers shared by the app shell and chrome.
 *
 * `isClassicShellRoute` marks the admin + rule-management screens that have not
 * been redesigned for the V2 interface. These always render inside the classic
 * `MainLayout` (and the V2 `data-*` theme attributes are stripped for them) so
 * they look correct without flipping the *whole* app back to classic. See
 * `App.tsx` (route split + `useApplyTheme(effectiveV2)`) and
 * `ProjectContextHeader` (which hides itself on these routes).
 */

/**
 * Whether a pathname is an admin/rule screen that must render in the classic
 * shell regardless of the V2 toggle.
 *
 * @param pathname - The current router pathname.
 * @returns True for `/admin`, any `/admin/*`, and any `/review/*` route.
 */
export function isClassicShellRoute(pathname: string): boolean {
  return (
    pathname === '/admin' ||
    pathname.startsWith('/admin/') ||
    pathname.startsWith('/review/')
  );
}
